<div class="search-detail__container">
  <div class="search-detail__header" mat-dialog-title >
    <div class="search-detail__header-text">
      {{ trDetailData.searchResponse?.matchedTerm }}
      <span class="search-detail__sub-heading">
        (#{{ trDetailData.searchResponse?.entityId || trDetailData.searchResponse?.referenceId }})
      </span>
    </div>
    <div class="search-detail__close" (click)="closeDialog()">
      <img class="themified-white-icon search-detail__close-icon" src="/assets/icons/cross-icon.png" />
    </div>
  </div>

  <div class="search-detail__content" mat-dialog-content>
    <!-- LAST REVIEW DATE -->
    <div class="search-detail__column">
      <div class="search-detail__title">
        LAST REVIEW DATE
      </div>
      <div class="search-detail__text">
        <div class="search-detail__item search-detail__item_md3">
          <span class="search-detail__item-text">{{trDetailData.searchResponse?.modificationDate ? (trDetailData.searchResponse?.modificationDate  | date:'dd/MM/yyyy') : '-'}}</span>
        </div>
      </div>
    </div>

    <!-- Also known as -->
    <ng-container *ngIf="trDetailData.searchResponse?.names && trDetailData.searchResponse?.names.length > 0">
      <div class="search-detail__column">
        <div class="search-detail__title">
          Also known as
        </div>
        <div class="search-detail__text">
          <ng-template ngFor let-item [ngForOf]="trDetailData.searchResponse?.names">
            <div class="search-detail__item search-detail__item_md3">{{ item?.fullName || '-' }}</div>
          </ng-template>
        </div>
      </div>
    </ng-container>

    <!-- Categories -->
    <ng-container *ngIf="trDetailData.searchResponse?.categories && trDetailData.searchResponse?.categories.length > 0">
      <div class="search-detail__column">
        <div class="search-detail__title">
          Category
        </div>
        <div class="search-detail__text">
          <ng-template ngFor let-item [ngForOf]="trDetailData.searchResponse?.categories">
            <div class="search-detail__item search-detail__item_md3">{{ item || '-' }}</div>
          </ng-template>
        </div>
      </div>
    </ng-container>

    <!-- Addresses -->
    <ng-container *ngIf="trDetailData.searchResponse?.addresses && trDetailData.searchResponse?.addresses.length > 0">
      <div class="search-detail__column">
        <div class="search-detail__title">
          Address
        </div>
        <div class="search-detail__text">
          <ng-template ngFor let-item [ngForOf]="trDetailData.searchResponse?.addresses">
            <div class="search-detail__item search-detail__three-column">
              {{ item.street || '-' }}<span *ngIf="item.street">,&nbsp;</span>
              {{ item.region || '-' }}<span *ngIf="item.region">,&nbsp;</span>
              {{ item.city || '-' }}<span *ngIf="item.city">,&nbsp;</span>
              {{ item.country?.name || '-' }}
            </div>
          </ng-template>
        </div>
      </div>
    </ng-container>

    <!-- Birthday and Gender -->
    <ng-container *ngIf="trDetailData.searchResponse?.events && trDetailData.searchResponse?.events?.length > 0">
      <div class="search-detail__column">
        <div class="search-detail__title">
          Birthday and Gender
        </div>
        <div class="search-detail__text">
          <ng-template ngFor let-item [ngForOf]="trDetailData.searchResponse?.events">
            <div class="search-detail__item search-detail__item_md6">
              <span class="search-detail__item-name">{{ item.type || '-' }}:</span>
              <span class="search-detail__item-text">{{ item.year }}-{{ item.month }}-{{ item.day }}</span>
            </div>
          </ng-template>
          <div class="search-detail__item search-detail__item_md6">
            <span class="search-detail__item-name">Gender:</span>
            <span class="search-detail__item-text">{{ trDetailData.searchResponse?.gender || '-' }}</span>
          </div>
        </div>
      </div>
    </ng-container>

    <!-- Countries -->
    <ng-container
      *ngIf="trDetailData.searchResponse?.countryLinks && trDetailData.searchResponse?.countryLinks?.length > 0">
      <div class="search-detail__column">
        <div class="search-detail__title">
          Country
        </div>
        <div class="search-detail__text">
          <ng-template ngFor let-item [ngForOf]="trDetailData.searchResponse?.countryLinks">
            <div class="search-detail__item search-detail__item_md6">
              <span class="search-detail__item-name">{{ item.type || '-' }}:</span>
              <span class="search-detail__item-text">{{ item.countryText || '-' }}</span>
            </div>
          </ng-template>
        </div>
      </div>
    </ng-container>

    <!-- Details -->
    <ng-container *ngIf="trDetailData.searchResponse?.details && trDetailData.searchResponse?.details.length > 0">
      <div class="search-detail__column">
        <div class="search-detail__title">
          Detail
        </div>
        <div class="search-detail__text">
          <ng-template ngFor let-item [ngForOf]="trDetailData.searchResponse?.details">
            <div class="search-detail__item search-detail__item_md12">
              <span class="search-detail__item-name">{{ item.title || '-' }}:</span>
              <span class="search-detail__item-text">
                {{ item.text || '-' }}
              </span>
            </div>
          </ng-template>
        </div>
      </div>
    </ng-container>

    <!-- Roles -->
    <ng-container *ngIf="trDetailData.searchResponse?.roles && trDetailData.searchResponse?.roles.length > 0">
      <div class="search-detail__column">
        <div class="search-detail__title">
          Role
        </div>
        <div class="search-detail__text">
          <ng-template ngFor let-item [ngForOf]="trDetailData.searchResponse?.roles">
            <div class="search-detail__item search-detail__item_md12">
              {{ item.title || '-' }}
            </div>
          </ng-template>
        </div>
      </div>
    </ng-container>

    <!-- Weblinks -->
    <ng-container *ngIf="trDetailData.searchResponse?.weblinks && trDetailData.searchResponse?.weblinks.length > 0">
      <div class="search-detail__column">
        <div class="search-detail__title">
          Weblink
        </div>
        <div class="search-detail__text">
          <ng-template ngFor let-item [ngForOf]="trDetailData.searchResponse?.weblinks">
            <a class="link link_underlined search-detail__item search-detail__item_md12" target="_blank" [href]="item.uri">
              {{ item.uri || '-' }}
            </a>
          </ng-template>
        </div>
      </div>
    </ng-container>
  </div>
</div>
